import React from 'react';

// ─── GurYou AI mark ───────────────────────────────────────────────────────────
// The GurYou brand icon (hexagonal "cube" outline + coral Y) combined with an AI
// sparkle accent. Use it everywhere AI is involved (AI Chat, AI Studio, AI
// suggestions, …) so the AI surface is instantly recognizable as GurYou's.
//
// The hexagon inherits the surrounding text color via `currentColor`, so the mark
// adapts to any context (gray in a toolbar, dark on light, etc.). The Y and the
// sparkle use the GurYou coral accent (override via `accent`).

const GyAiIcon = ({ size = 22, className = '', style, accent = '#E6616A', title = 'AI' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-label={title}
  >
    {/* GY hexagon (cube outline) */}
    <path d="M11 2.5 19.5 7.25 19.5 16.75 11 21.5 2.5 16.75 2.5 7.25Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    {/* coral Y (the three visible cube edges meeting at the centre) */}
    <path
      d="M11 12 2.5 7.25M11 12 19.5 7.25M11 12 11 21.5"
      fill="none"
      stroke={accent}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* AI sparkle accent at the top-right corner */}
    <g transform="translate(13.14 -1.71) scale(0.57)">
      <path d="M12 3c.4 4.6 2.4 6.6 7 7-4.6.4-6.6 2.4-7 7-.4-4.6-2.4-6.6-7-7 4.6-.4 6.6-2.4 7-7Z" fill={accent} />
    </g>
  </svg>
);

export default GyAiIcon;
